@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}

@keyframes wave {
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.skeleton {
  display: block;
  background-color: var(--tuna-palette-action-hover);
  border-radius: var(--tuna-shape-borderRadius);
  animation: pulse 2s ease-in-out 0.5s infinite;
}

.text {
  height: auto;
  transform: scale(1, 0.6);
  transform-origin: 0 60%;
  border-radius: calc(var(--tuna-shape-borderRadius) / 0.6);
}

.text::before {
  content: '\00a0';
}

.circular {
  border-radius: 50%;
}

.rounded {
  border-radius: calc(var(--tuna-shape-borderRadius) * 2);
}

.wave {
  animation: none;
  position: relative;
  overflow: hidden;
}

.wave::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, transparent, var(--tuna-palette-action-hover), transparent);
  animation: wave 2s linear 0.5s infinite;
}
